import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_POS_ENTRY_MODE,
  UPDATE_POS_ENTRY_MODE,
} from "./actionTypes";

import {
  apiPosEntryModeApiError,
  getPosEntryModeListSuccess,
  updatePosEntryModeSuccess,
} from "./actions";

import {
  getPosEntryModeList,
  updatePosEntryMode,
} from "../../helpers/backend_helper/backend_helper";

import {toast, Zoom} from "react-toastify";
import i18n from 'i18n';

function* onGetPosEntryModeList() {
  try {
    const response = yield call(getPosEntryModeList);
    yield put(getPosEntryModeListSuccess(response));
  } catch (error) {
    yield put(apiPosEntryModeApiError(error));
  }
}

function* onUpdatePosEntryMode({ payload: record }) {
  try {
    const response = yield call(updatePosEntryMode, record);
    yield put(updatePosEntryModeSuccess(response));
    toast.success(i18n.t('successful'), {autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom});
  } catch (error) {
    yield put(apiPosEntryModeApiError(error));
  }
}

function* posEntryModeSaga() {
  yield takeEvery(GET_POS_ENTRY_MODE, onGetPosEntryModeList);
  yield takeEvery(UPDATE_POS_ENTRY_MODE, onUpdatePosEntryMode);
}

export default posEntryModeSaga;
